export default __webpack_public_path__ + "static/media/bike-store-2.8a56e5ee.webp";